/**
 * Announcement-Popup-Utils (Phase 128).
 * Style-Presets, Größen und Layouts werden zentral hier definiert, damit
 * Public-Popup und Admin-Editor exakt gleich aussehen.
 */

export const PRESETS = {
  sky: {
    label: 'Sky / Blau (Info)',
    ring: 'border-sky-200',
    header: 'bg-sky-50 text-sky-900',
    accent: 'text-sky-700',
    dot: 'bg-sky-500',
    btn: 'bg-sky-600 hover:bg-sky-700 text-white',
    iconBg: 'bg-sky-100 text-sky-700',
  },
  red: {
    label: 'Rot / Alarm (dringend)',
    ring: 'border-red-200',
    header: 'bg-red-50 text-red-900',
    accent: 'text-red-700',
    dot: 'bg-red-500',
    btn: 'bg-red-600 hover:bg-red-700 text-white',
    iconBg: 'bg-red-100 text-red-700',
  },
  green: {
    label: 'Grün / Deal (Angebot)',
    ring: 'border-emerald-200',
    header: 'bg-emerald-50 text-emerald-900',
    accent: 'text-emerald-700',
    dot: 'bg-emerald-500',
    btn: 'bg-emerald-600 hover:bg-emerald-700 text-white',
    iconBg: 'bg-emerald-100 text-emerald-700',
  },
  amber: {
    label: 'Amber / Warm (Einschulung, Feiertag)',
    ring: 'border-amber-200',
    header: 'bg-amber-50 text-amber-900',
    accent: 'text-amber-700',
    dot: 'bg-amber-500',
    btn: 'bg-amber-600 hover:bg-amber-700 text-white',
    iconBg: 'bg-amber-100 text-amber-700',
  },
};

export const SIZES = {
  sm: { label: 'S', cls: 'max-w-md' },
  md: { label: 'M', cls: 'max-w-lg' },
  lg: { label: 'L', cls: 'max-w-2xl' },
  xl: { label: 'XL', cls: 'max-w-3xl' },
};

export const LAYOUTS = {
  centered_dialog: { label: 'Zentriert (Dialog)' },
  top_banner: { label: 'Oberer Banner' },
  bottom_sheet: { label: 'Unten (Sheet)' },
  corner_toast: { label: 'Ecke rechts unten (Toast)' },
};

// Prüft, ob ein Pfad einem Glob-Muster entspricht ("*" = Wildcard).
export const matchesPath = (path, pattern) => {
  if (!pattern || pattern === '*' || pattern === '/**') return true;
  const re = new RegExp(
    '^' + pattern
      .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
      .replace(/\*\*/g, '.*')
      .replace(/\*/g, '[^/]*') + '$',
  );
  return re.test(path);
};

export const shouldShowOnPath = (announcement, path) => {
  const patterns = announcement.path_patterns || [];
  if (patterns.length === 0) return true;   // leer = überall
  return patterns.some((p) => matchesPath(path, p));
};

// LocalStorage-Key für „einmal pro Tag pro Gerät".
export const dismissKey = (id) => {
  const day = new Date().toISOString().slice(0, 10);
  return `announcement_shown_${day}_${id}`;
};
